import TdClient from 'tdweb';
import {StoreHelper} from './store';

export class ApiHelper {
  parameters: any;
  client: TdClient;
  storeHelper: StoreHelper;

  subscribers = [];
  userId;

  constructor(storeHelper: StoreHelper) {
    this.storeHelper = storeHelper;

    this.parameters = {
      useTestDC: false,
      readOnly: false,
      verbosity: 1,
      jsVerbosity: 3,
      fastUpdating: true,
      useDatabase: false,
      mode: 'wasm',
    };

    const {verbosity, jsVerbosity, useTestDC, readOnly, useDatabase, mode} = this.parameters;

    let options = {
      logVerbosityLevel: verbosity,
      jsLogVerbosityLevel: jsVerbosity,
      mode: mode,
      prefix: useTestDC ? 'tdlib_test' : 'tdlib',
      readOnly: readOnly,
      isBackground: false,
      useDatabase: useDatabase,
    };

    this.client = new TdClient(options);

    this.client.onUpdate = update => {
      // console.log('update: ', update);
      if (update['@type'] === 'updateAuthorizationState') {
        this.updateAuthState(update['authorization_state']);
      } else if (update['@type'] === 'updateOption' && update.name === 'my_id' && !this.userId) {
        this.userId = update.value.value;
      } else {
        this.subscribers.forEach(subs => subs(update));
      }
    };
  }

  updateAuthState(authState: any) {
    switch (authState['@type']) {
      case 'authorizationStateWaitTdlibParameters':
        this.setParams();
        break;
      case 'authorizationStateWaitEncryptionKey':
        this.send({'@type': 'checkDatabaseEncryptionKey'});
        break;
      default:
        this.storeHelper.setStore({authState});
    }
  }

  send = (request: any) => {
    return this.client
      .send(request)
      .then(result => {
        // console.log('receive result', result);
        return result;
      })
      .catch(error => {
        // console.error('catch error', error);

        throw error;
      });
  };

  setParams = () => {
    this.send({
      '@type': 'setTdlibParameters',
      parameters: {
        '@type': 'tdParameters',
        use_test_dc: this.parameters.useTestDC,
        api_id: 999106,
        api_hash: '6c89c3d9f015506cf1b538b1babe985e',
        system_language_code: navigator.language || 'en',
        device_model: 'Nokia 3310',
        system_version: '300',
        application_version: '300',
        use_secret_chats: false,
        use_message_database: true,
        use_file_database: false,
        database_directory: '/db',
        files_directory: '/',
      },
    });
  };

  setPhoneNumber = (phone: any) => {
    return this.send({
      '@type': 'setAuthenticationPhoneNumber',
      phone_number: phone,
    });
  };

  setPasscode = (code: any, firstName?: string, lastName?: string) => {
    return this.send({
      '@type': 'checkAuthenticationCode',
      code,
      first_name: firstName,
      last_name: lastName,
    });
  };

  registerUser = (first_name: string, last_name: string) => {
    return this.send({
      '@type': 'registerUser',
      first_name,
      last_name,
    });
  };

  setPassword = (password: string) => {
    return this.send({
      '@type': 'checkAuthenticationPassword',
      password,
    });
  };

  setUserPic = (photo: any) => {
    return this.send({
      '@type': 'setProfilePhoto',
      photo,
    });
  };

  logOut = () => {
    return this.send({'@type': 'logOut'});
  };

  getChats(chatInfo) {
    if (!chatInfo) {
      chatInfo = {
        order: '9223372036854775807',
        id: 0,
      };
    }

    return this.send({
      '@type': 'getChats',
      offset_chat_id: chatInfo.id,
      offset_order: chatInfo.order,
      limit: 50,
    });
  }

  getChat(chatId: number) {
    return this.send({
      '@type': 'getChat',
      chat_id: chatId,
    });
  }

  downloadFile(fileId, priority = 1) {
    return this.send({
      '@type': 'downloadFile',
      file_id: fileId,
      priority,
    });
  }

  getFile(fileId, priority = 1) {
    return this.send({
      '@type': 'readFile',
      file_id: fileId,
      priority,
    });
  }

  getMessages(chatId, fromMessageId = 0) {
    return this.send({
      '@type': 'getChatHistory',
      chat_id: chatId,
      from_message_id: fromMessageId,
      offset: 0,
      limit: 100,
    });
  }

  viewMessages(chatId, messageIds) {
    return this.send({
      '@type': 'viewMessages',
      chat_id: chatId,
      message_ids: messageIds,
    });
  }

  openChat(chatId) {
    return this.send({
      '@type': 'openChat',
      chat_id: chatId,
    });
  }

  closeChat(chatId) {
    return this.send({
      '@type': 'closeChat',
      chat_id: chatId,
    });
  }

  getSupergroupFullInfo(groupId) {
    return this.send({
      '@type': 'getSupergroupFullInfo',
      supergroup_id: groupId,
    });
  }
}
